import React from 'react';
import '../CompassPrivacyPolicy/style.css';
import ContactCompass from '../CompassPrivacyPolicy/ContactCompass';

const CompassTermsAndConditions = () => {
  return (
    <>
      <div className="compass-policy-body">
        <main className="compass-page">
          <header className="compass-header">
            <h1 className="compass-title">Compass Digital</h1>
            <div className="compass-brand">
              <span className="compass-brand-text">Terms and Conditions</span>
            </div>
            <p className="compass-last-updated">Last updated: 10 Sep, 2025</p>
          </header>

          <section className="compass-card">
            <div className="compass-content">
              <h2 className="compass-section-title">1. Acceptance of Terms</h2>
              <p className="compass-paragraph">
                By downloading, installing, or using the Compass Digital application (the "App"), you agree to be bound by these
                Terms and Conditions. If you do not agree, do not use the App.
              </p>

              <h2 className="compass-section-title">2. Description of the App</h2>
              <p className="compass-paragraph">
                Compass Digital provides a digital compass and related location information, such as heading, latitude/longitude, and
                accuracy readings, based on your device's sensors and GPS capabilities.
              </p>

              <h2 className="compass-section-title">3. Eligibility</h2>
              <p className="compass-paragraph">
                You must be able to form a binding contract in your jurisdiction to use the App. If you are using the App on behalf
                of an organization, you represent that you have authority to bind that organization.
              </p>

              <h2 className="compass-section-title">4. Permissions and Location Data</h2>
              <p className="compass-paragraph">
                The App requires access to your device's location services and motion/sensor data to function properly. By using the
                App, you consent to the collection and processing of such data to provide features like heading, accuracy, and
                position updates.
              </p>
              <ul className="compass-bullets">
                <li>Location data is processed on-device and/or transmitted as needed to enable app functionality.</li>
                <li>You can revoke permissions at any time via your device settings; some features may stop working without permissions.</li>
              </ul>

              <h2 className="compass-section-title">5. Accuracy and Safety Disclaimer</h2>
              <p className="compass-paragraph">
                The App relies on hardware sensors, environmental conditions, and GPS signals that may be inaccurate or unavailable.
                The App is provided for general information and utility purposes only and is not intended for critical navigation,
                aviation, maritime, or emergency use.
              </p>
              <ul className="compass-bullets">
                <li>Always verify your direction using multiple sources when safety is at stake.</li>
                <li>The developer does not guarantee accuracy, availability, or reliability of readings.</li>
              </ul>

              <h2 className="compass-section-title">6. Acceptable Use</h2>
              <ul className="compass-bullets">
                <li>Do not use the App in a manner that violates laws or third-party rights.</li>
                <li>Do not attempt to reverse engineer, modify, or interfere with the App or its services.</li>
                <li>Do not use the App while situations requiring full attention.</li>
              </ul>

              <h2 className="compass-section-title">7. Ads and Third-Party Services</h2>
              <p className="compass-paragraph">
                The App may display ads or link to third-party content. Your interactions with such third parties are solely between
                you and them. We are not responsible for third-party content, products, or services.
              </p>

              <h2 className="compass-section-title">8. Intellectual Property</h2>
              <p className="compass-paragraph">
                All rights, title, and interest in and to the App, including text, graphics, logos, and software, are owned by their
                respective owners and are protected by applicable laws. You are granted a limited, non-exclusive, non-transferable
                license to use the App for personal, non-commercial purposes.
              </p>

              <h2 className="compass-section-title">9. Termination</h2>
              <p className="compass-paragraph">
                We may suspend or terminate your access to the App at any time, with or without notice, for any reason, including
                suspected violations of these Terms.
              </p>

              <h2 className="compass-section-title">10. Limitation of Liability</h2>
              <p className="compass-paragraph">
                To the maximum extent permitted by law, the App and its developers shall not be liable for any indirect, incidental,
                special, consequential, or exemplary damages, including loss of data, accuracy, or profits, arising from your use of or
                inability to use the App.
              </p>

              <h2 className="compass-section-title">11. Indemnification</h2>
              <p className="compass-paragraph">
                You agree to indemnify and hold harmless the developer from any claims, liabilities, damages, and expenses arising out
                of your use of the App or violation of these Terms.
              </p>

              <h2 className="compass-section-title">12. Changes to the App or Terms</h2>
              <p className="compass-paragraph">
                We may modify or discontinue the App, and update these Terms from time to time. Continued use of the App after updates
                constitutes acceptance of the revised Terms.
              </p>

              <h2 className="compass-section-title">13. Privacy</h2>
              <p className="compass-paragraph">
                Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, and protect your
                information.
              </p>

              <h2 className="compass-section-title">14. Contact</h2>
              <p className="compass-paragraph">
                For questions or support regarding the App or these Terms, email us at:
              </p>
                <ContactCompass/>
              <div className="compass-footer-note" role="note">
                Use Compass Digital responsibly. Always prioritize your safety.
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default CompassTermsAndConditions;
